import { render } from "./TransportationOrderInfoComponent.vue?vue&type=template&id=071bd00b&scoped=true"
import script from "./TransportationOrderInfoComponent.vue?vue&type=script&lang=js"
export * from "./TransportationOrderInfoComponent.vue?vue&type=script&lang=js"

import "./TransportationOrderInfoComponent.vue?vue&type=style&index=0&id=071bd00b&scoped=true&lang=scss"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071bd00b"]])

export default __exports__